import styled from 'styled-components/macro';

export const DocumentIFrame = styled.iframe`
  width: 100%;
  height: 80vh;
  border: none;
`;
